'use client';

import {
  Box,
  Card,
  CardActionArea,
  CardContent,
  CardMedia,
  Grid,
  Typography,
} from '@mui/material';
import { api_portalOfficeListingAllType_portalOfficeResponse } from '@/init/swagger';
import { useLogic } from './logic';

type Props = {
  portalOfficeListings: api_portalOfficeListingAllType_portalOfficeResponse[];
};

export function PublicHomeLatestPortalOfficeListingList({
  portalOfficeListings,
}: Props) {
  const { latestPortalOfficeListings, emblaRef } = useLogic({
    portalOfficeListings,
  });

  return (
    <Box
      sx={{
        width: '100%',
        ':hover': {
          '.slide-count': {
            display: 'block',
          },
          '.nav-button': {
            display: 'inline-flex',
            bgcolor: 'white',
            ':disabled': {
              bgcolor: 'transparent',
            },
            ':hover': {
              bgcolor: '#f5f5f5',
            },
          },
        },
      }}
    >
      <Box
        className="slide-container"
        ref={emblaRef}
        sx={{ overflow: 'hidden', width: '100%', borderRadius: 1 }}
      >
        <Box sx={{ display: 'flex' }}>
          {latestPortalOfficeListings?.map((info, officeIndex) => (
            <CardActionArea
              key={officeIndex}
              href={info.href}
              target="_blank"
              sx={{
                marginLeft: '16px',
                width: 343,
                height: 300,
                gap: 16,
              }}
            >
              <Card sx={{ width: 343, height: 296, gap: 16, p: 2 }}>
                <CardMedia
                  component="img"
                  sx={{
                    maxWidth: 311,
                    height: 160,
                    my: 'auto',
                    borderRadius: 2,
                  }}
                  image={info.image}
                  alt={info.alt}
                />

                <CardContent sx={{ px: 0 }}>
                  <Grid container mb={1.5} direction="row" alignItems="center">
                    <Grid
                      size={{
                        xs: 8,
                      }}
                    >
                      <Typography variant="JP/Heading/s/Bold/Tight">
                        {info.name}
                      </Typography>
                    </Grid>
                  </Grid>
                </CardContent>
              </Card>
            </CardActionArea>
          ))}
        </Box>
      </Box>
    </Box>
  );
}
